import logo from '@src/assets/images/logo/logo.webp';


const SpinnerComponent = () => {
    return (
        <div className='fallback-spinner vh-100'>
            <div className="image-wrapper">
                <img className='fallback-logo' width={150} src={logo} alt='logo'/>
            </div>
      {/*      <div className='loading'>
                <div className='effect-1 effects'></div>
                <div className='effect-2 effects'></div>
                <div className='effect-3 effects'></div>
            </div>*/}
        </div>
    )
}

export default SpinnerComponent